import { ComponentProps } from "react";

export default function UserIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="8" cy="4" r="3.5" stroke="currentColor" />
      <path
        d="M15 16C15 12.134 11.866 9 8 9C4.13401 9 1 12.134 1 16"
        stroke="currentColor"
      />
    </svg>
  );
}
